import { Icon } from '@innovamat/glimmer-components';

import useSpaces from '../useSpaces';
import {
  NoMessageSecondaryMessage,
  NoSpacesMainMessage,
  NoSpacesMessageContainer,
  PinWrapper,
} from './EmptyPinnedList.styles';

export function EmptyPinnedList() {
  const { t } = useSpaces();

  return (
    <NoSpacesMessageContainer>
      <PinWrapper>
        <Icon icon="InfoIcon" /> {/* TODO: Crear icono Pin en glimmer-icons */}
      </PinWrapper>
      <NoSpacesMainMessage>{t('spaces.emptyState.title')}</NoSpacesMainMessage>
      <NoMessageSecondaryMessage>
        {t('spaces.emptyState.subtitle')}
      </NoMessageSecondaryMessage>
    </NoSpacesMessageContainer>
  );
}
